import { WhatsappTemplateButton } from 'src/app/parameters/message-templates/whatsapp-templates/shared/models/whatsapp-template-button.model';
import { BZCSplittableRichLink } from 'src/app/task-process/shared/models';

import { SiteTypeEnum } from '../enums';

/**
 * @deprecated prefer to use `src/app/shared/models/site-v2.model.ts` instead.
 */
export interface Site {
  id: number;
  type: SiteTypeEnum;
  typeInt: number;
  name: string;
  type_name: string;
}

export interface Channel {
  id?: number;
  siteTypeName: SiteTypeEnum;
  taskTypeName?: string;
  isCategory: boolean;
}

export interface Team {
  id: number;
  name: string;
}

export interface MessageSenderForLogAnswer {
  id: number;
  name: string;
}

export interface MessageSender extends MessageSenderForLogAnswer {
  handle?: string; // @twitterhandle
  phoneNumber?: string; // +33612345678, whatsapp only
  isVIP: boolean;
  avatarURL: string;
  external_id?: string;

  isSelected?: boolean; // set by the UI
}

export interface AdminUser {
  id: number;
  name: string;
  email?: string;
  realname?: string;
}

export enum TaskState {
  Pending = 'pending',
  Assigned = 'assigned',
  HelpRequested = 'help-requested',
  HelpAnswered = 'help-answered',
  Archived = 'archived',
  AutoArchived = 'archived-auto',
  Answered = 'answered',
  OnHold = 'on-hold',
}

// And also in inbox
export enum TaskStateInWsNotif {
  Pending = 'pending',
  Assigned = 'assigned',
  HelpRequested = 'help_requested',
  HelpAnswered = 'help_answered',
  Archived = 'archived',
  AutoArchived = 'archived_auto',
  Answered = 'answered',
  OnHold = 'on_hold',
}

export interface TaskStateAndAdminUser {
  taskStateCode: TaskState; // pending|help-answered...
  adminUser?: AdminUser;
}

export interface TaskUpdate {
  taskId: number;
  state?: TaskStateAndAdminUser;
}

export interface Editor2Attachment {
  type: string; // 'picture|video|...'
  value:
    | {
        pictureId?: number;
        videoId?: number;
        messageAttachementURL?: string;
      }
    | BZCSplittableRichLink
    | any; // BZC rich link too
  mimeType?: string;
  isValid?: boolean;
}

export enum AttachmentType {
  Picture = 'picture', // PP
  Image = 'image', // inbox
  ShopProduct = 'shopProduct',
  Video = 'video',
  Audio = 'audio',
  File = 'file',
  Link = 'link',
  BZCRichLink = 'bzcRichLink',
  BZCSplittableRichLink = 'BZCSplittableRichLink',
  AgentShortcut = 'agentShortcut',
}

export enum AttachmentMediaTypeEnum {
  Image = 'image',
  Video = 'video',
  Document = 'document',
}

export interface ShopProductInfo {
  productId: string;
  productUrl: string;
  name: string;
  price: string; // '150€'
  imageUrl: string;
}

export interface LinkInMessage {
  start: number;
  end: number;
  url: string;
}

export interface Editor2Link extends LinkInMessage {
  wrap: boolean;
}

// see alcmeon-prod/sites/admin2/client/app/components/editor2/editor2.directive.js
export interface Editor2Answer {
  text: string;
  links: Editor2Link[];
  attachments: Editor2Attachment[];
  /**
   * @deprecated
   */
  is_whatsapp_template_mode?: boolean;
  /**
   * @deprecated
   */
  params?: string[];
  /**
   * @deprecated
   */
  template?: { id: number };
  /**
   * @deprecated
   */
  headerMediaUrl?: string;
  /**
   * @deprecated
   */
  headerMediaFilename?: string;

  pictures?: number[];

  extra_data?: {
    is_whatsapp_template: boolean;
    id?: number; // PP
    whatsapp_template_id?: number; // Engagement
    header?: {
      media_url?: string; // PP
      filename?: string; // PP
      headerMediaUrl?: string; // Engagement
      headerMediaFilename?: string; // Engagement
      media_type: string;
      type: string;
    };
    text?: string; // PP
    body?: string; // Engagement
    params?: any;
    footer: string;
    buttons?: WhatsappTemplateButton[];
    button_params: {
      urlButtonParams: { [key: string]: string };
      couponCodeButtonParams: { couponCode: string };
      quickReplyButtons: WhatsappTemplateButton[];
    };
  };
}

export interface ValueAndUnit {
  value: number;
  unit: string; // second/minute/.../year, not translated
}

export enum Unit {
  Year = 'year',
  Month = 'month',
  Day = 'day',
  Hour = 'hour',
  Minute = 'minute',
  Second = 'second',
}

export interface TagGroup {
  dependsUpon?: any[];
  displayOrder?: number;
  id: number;
  isLanguage?: boolean;
  isMandatory?: number;
  isMandatoryAndMissing?: boolean;
  isRouting?: boolean;
  isVisible?: boolean;
  isVisibleAndNotRouting?: boolean;
  name: string;
  noneTagId?: number;
  selectedTagId?: number;
  tags: Tag[];
}

export interface Tag {
  id: number;
  name: string;
  isCategory: boolean;
  languageCode?: string; // only set for tags of the language tag group
  dependsUpon?: any[];

  // set by the UI
  nameForSearch: string; // name without diacritics and in lowercase
}

export interface BlobAndFileName {
  blob: Blob;
  fileName: string;
}

export interface BlobFileNameAndAttachmentType extends BlobAndFileName {
  attachmentType: AttachmentType;
}

export interface TimezonesByOffset {
  // offset is a string even though it is a numerical value, because the timezones are fetched as JSON
  [offset: string]: string[];
}

export type DropdownItem = {
  id: string | number;
  label: string;
};

export interface UploadMediaResponse {
  media_id: number;
}

export interface CreateVideoReply {
  video_id: number;
}

export interface UploadFileResponse {
  file_id: number;
}

export interface CSSInset {
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
}
